export const pin = "$ab";
export default {pin};